import { ServiceData } from '../service';
import db from '../index';
import { entityServiceFactory } from '../entityServiceFactory';

export interface IssueWorkflowsServiceData extends ServiceData {}

const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<IssueWorkflowsServiceData>(
    db,
    'issueWorkflowsService'
  );

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
